var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-switch',{staticClass:"mx-auto text-center cont-sw",attrs:{"disabled":!_vm.cmpPermisos,"hide-details":"","label":_vm.valor ? 'SI' : 'NO',"loading":_vm.bLoad},on:{"change":_vm.onCambiarValor},model:{value:(_vm.valor),callback:function ($$v) {_vm.valor=$$v},expression:"valor"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }